import { useState, useRef } from 'react';

export const useTestExecutionState = () => {
  const [testExecutions, setTestExecutions] = useState([]);
  const [showFavorites, setShowFavorites] = useState(false);
  const [showScheduled, setShowScheduled] = useState(false);

  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedToCancelIds, setSelectedToCancel] = useState([]);
  const [selectedToSchedule, setSelectedtoSchedule] = useState([]);

  // Modals
  const [showModal, setShowModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showSingleDeleteModal, setShowSingleDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const selectedToRerunTest = useRef();

  return {
    testExecutions,
    setTestExecutions,
    showFavorites,
    setShowFavorites,
    showScheduled,
    setShowScheduled,

    selectedIds,
    setSelectedIds,
    selectedToCancelIds,
    setSelectedToCancel,
    selectedToSchedule,
    setSelectedtoSchedule,

    showModal,
    setShowModal,
    showCancelModal,
    setShowCancelModal,
    showSingleDeleteModal,
    setShowSingleDeleteModal,
    showEditModal,
    setShowEditModal,

    selectedToRerunTest,
  };
};
